import {call, put, takeLatest, delay} from 'redux-saga/effects'
import {actions} from './action'
import {actionTypes} from './constants'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {service} from './service'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'
import {globalActionTypes} from 'src/app/modules/errors/redux/constants'
import {ParamsModel} from 'src/app/modules/common/Model'

function* getLeadFormDetailSaga(action: ActionModel) {
  try {
    const params: ParamsModel = action.payload
    yield delay(500)
    const response: ResponseModel = yield call(service.getLeadFormDetail, params)
    yield put(actions.getLeadFormDetailSuccess(response?.data?.data))
    yield put(actions.getLeadFormDetailFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.getLeadFormDetailFinish())
  }
}

//Get branchless file
function* exportLeadFormDetailFileSaga(action: ActionModel) {
  try {
    const fileName: any = action.payload.fileName
    const params: any = action.payload.params
    const response: ResponseModel = yield call(service.exportLeadFormDetailFile, fileName, params)
    const responseData: any = response?.data
    yield put(actions.exportFileSuccess(responseData))
    yield put(actions.exportFileError())
  } catch (error: any) {
    if (error.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: error.response.data.message})
    }
    yield put(actions.exportFileError())
  }
}

function* setLeadContactedSaga(action: ActionModel) {
  const {id, isContacted, params} = action.payload as unknown as {
    id: string
    isContacted: boolean
    params: ParamsModel
  }
  try {
    yield call(service.setLeadContacted, id, isContacted)
  } catch (error: any) {
    if (error.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: error.response.data.message})
    }
  }
  yield put(actions.getLeadFormDetail(params))
}

export function* saga() {
  yield takeLatest(actionTypes.GET_LEAD_FORM_DETAIL_START, getLeadFormDetailSaga)
  yield takeLatest(actionTypes.EXPORT_LEAD_FORM_DETAIL_FILE_START, exportLeadFormDetailFileSaga)
  yield takeLatest(actionTypes.SET_LEAD_FORM_CONTACTED_START, setLeadContactedSaga)
}
